import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

export default function StoreSignals() {
  const location = useLocation();
  useEffect(() => {
    let visitorId = localStorage.getItem("spicy3d_visitor_id");
    if (!visitorId) { visitorId = crypto.randomUUID(); localStorage.setItem("spicy3d_visitor_id", visitorId); }
    api.post("/analytics/visit", { visitor_id: visitorId, path: location.pathname }).catch(() => {});
  }, [location.pathname]);
  return null;
}